<template>
  <div class="row">
    <SideBar/>
    <nav class="col s12 m12 l10 right white">
      <div class="nav-wrapper">
        <form>
          <div class="input-field">
            <input id="search" type="search" v-model="search" required>
            <label class="label-icon" for="search"><i class="material-icons grey-text">search</i></label>
            <i class="material-icons">close</i>
          </div>
        </form>
      </div>
    </nav>
    <div class="col s12 m12 l10 right">
      <div class="col s12 center" v-if="users.list.length < 1">
        <div class="preloader-wrapper big active" style="margin-top:5%">
          <div class="spinner-layer spinner-blue-only">
            <div class="circle-clipper left"><div class="circle"></div></div>
            <div class="gap-patch"><div class="circle"></div></div>
            <div class="circle-clipper right"><div class="circle"></div></div>
          </div>
        </div>
        <h6 class="indigo-text">Cargando...</h6>
      </div>
      <div class="col s12 m12 l8">
        <div class="collection no-border" v-if="users.list.length > 1">
          <div class="col s12" :key="index" v-for="(user,index) in filteredList ">
              <div v-on:click="counter += 1" class="collection-item avatar transparent no-border waves-effect">
                <img :src="getImgUrl()" alt="" class="circle">
                <!--<i class="hide circle material-icons mobile-no-show" data-position="top" data-delay="5" data-tooltip="">mood</i>-->
                <b class="grey-text text-darken-3 text-trasnform">{{user.name}}</b>
                <p class="grey-text">{{user.mail}}</p>
                <p class="chip" v-bind:class="getRol(user.fRol).color+' lighten-4'">
                    <span v-bind:class="getRol(user.fRol).color+'-text'">{{getRol(user.fRol).name}}</span>
                </p>
              </div>
          </div>
        </div>
      </div>
      <div class="col s4">
        
      </div>
    </div>
  </div>
</template>
<script>
import M from 'materialize-css'
import * as firebase from "firebase/app"
import SideBar from '../components/SideBar'
export default{
  data: function() {
      return {
        "search": "",
        "users":{"list":[]}
      }
  },
  components:{
    SideBar
  },
  created: function () {
    this.$root.validateSesion()
    this.users = this.getUsersList()
  },
  beforeCreate: ()=>{
    M.Tooltip.init(document.querySelectorAll('.tooltipped'));
  },
  methods:{
    limitText (text) {
      let body = this.stripTags(text);
      return body.length > 20 ? body.substring(0, 20) + '...' : body
    },
    stripTags (text) {
        return text.replace(/(<([^>]+)>)/ig, '')
    },
    getImgUrl() {
      var images = require.context('../assets/img/faces/colored/', false, /\.jpg/)
      return images('./' + Math.round(Math.random()*5) + ".jpg")
    },
    getRol (rol) {
      switch (rol) {
        case "1":
          return {"color":"purple","name":"Administrador"}
        case "2":
          return {"color":"orange","name":"Usuario"}
        case "3":
          return {"color":"blue","name":"Comercial"}
        case "4":
          return {"color":"cyan","name":"Auditor"}
        case "5":
          return {"color":"pink","name":"Agencia"}
        default:
        return {"color":"pink","name":"Agencia"}
      }
    },
    getUsersList: function() {
      this.users = {
        ref: firebase.database().ref('users'),
        list: []
      }
      this.users.ref.once('value', (snapshot)=> {
        snapshot.forEach((childSnapshot)=> {
          this.users.list.push(childSnapshot.val())
        });
      });
      return this.users
    },
    clickUser:function (user) {
      console.log(user);
    },
    getCountry:function(country) {
      if (country=="Bogotá") {
        return "Bogotá"
      }
      var i = 0
      for (i = 0; i < this.cities.list.length; i++) {
          if (i == parseInt(country)) {
            return this.cities.list[i]
          }
      }
    }
  },
  computed: {
    filteredList() {
      return this.users.list.filter((user) => {
        return user.name.toLowerCase().includes(this.search.toLowerCase());
      });
    }
  }
}
</script>
